<bizz-modal modalSize="sm"
            [title]="'Signature' | translate"
            [message]="'SignatureTitleInfo' | translate"
            [contentTemplate]="contentTemplateRef"
            [footerTemplate]="footerTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <div class="modal-content flex flex-col justify-center items-center gap-4">
        @if (data.userName != undefined) {
            <div class="flex items-center justify-between w-full gap-2 flex-wrap">
                <label class="min-w-24 w-auto"> <b>{{ "User" | translate }}</b> </label>
                <input class="min-w-40 w-auto" type="text" [value]="data.userName" readonly [disabled]="true"/>
            </div>
        }

        <div class="flex flex-col w-full gap-2">
            <label> <b>{{ "Signature" | translate }}</b> </label>
            @if (data.readOnly || editMode) {
                <div class="relative w-full flex justify-center items-center rounded border
                border-form-control bg-form-control">
                    <span class="absolute z-1 w-full h-full rounded shadow-[0_0_16px_0_rgba(102,198,242,0.25)_inset]"></span>
                    <img class="w-full rounded" [src]="data.signature"/>
                </div>
            } @else {
                @if (canvasOptions) {
                    <bizz-canvas-control class="w-full h-full" [(ngModel)]="data.signature" [signatureMode]="true"
                                         [configOverrides]="canvasOptions" #canvasPad></bizz-canvas-control>
                }
            }
        </div>
    </div>
</ng-template>

<ng-template #footerTemplateRef>
    <div class="modal-buttons">
        <button class="default" (click)="dialogRef.close()">
            {{ 'Cancel' | translate }}
        </button>
        @if (editMode && !data.readOnly) {
            <button class="button delete" (click)="clear()">
                {{ 'Clear' | translate }}
            </button>
        }
        <button class="button save" (click)="data.readOnly ? dialogRef.close() : save()">
            {{ 'Ok' | translate }}
        </button>
    </div>
</ng-template>